export const signOut = (redirect?: boolean) => {
  localStorage.removeItem('token')
  localStorage.removeItem('userType')
  redirect && window.location.assign('/')
}
